export const siteConfig = {
  name: "LAKVERSE",
  description: "LAKVERSE - Profesyonel web tasarım, mobil uygulama geliştirme, e-ticaret çözümleri ve yapay zeka destekli dijital dönüşüm hizmetleri. Modern teknolojilerle işletmenizi dijital dünyada öne çıkarıyoruz.",
  url: process.env.NEXT_PUBLIC_SITE_URL || "http://localhost:3000",
  ogImage: "/og-image.jpg",
  links: {
    email: "info@lakverse.com",
    phone: "0090 531 722 1489",
    whatsapp: "905317221489",
    address: "Workinton Carousel, Fişekhane Cad. No: 5, Carousel AVM 2B Katı, 34710 Bakırköy / İstanbul",
  },
  social: {
    instagram: "https://www.instagram.com/lakverseofficial/",
    facebook: "https://www.facebook.com/lakverse",
    twitter: "https://twitter.com/lakverse",
    linkedin: "https://www.linkedin.com/company/lakverse",
  },
}

